export default {
    title_list: 'Списки кругов',
    title_page: 'Список круга',
    title_create_page: 'Создать список круга',
    title_edit_page: 'Изменить список круга',

    filter: {
        labels: {

        }
    },

    table: {
        labels: {
            id: 'ID',
            user_id: 'Владелец',
            name: 'Название',
            members: 'Кол-во участников',
        }
    },

    buttons: {

    },

    form: {
        user_id: 'Владелец',
        name: 'Название'
    },
}
